(function () {
  'use strict';

  var DEFAULT_ACCENT = '#8DBFDF';

  var DEFAULT_CAMPAIGN = {
    id: null,
    market: null,
    label: '',
    eyebrow: '',
    banner: '',
    cta: '',
    slides: [],
    bannerFrom: DEFAULT_ACCENT,
    bannerTo: DEFAULT_ACCENT,
    bannerTextColor: '#FFFFFF',
    offerColor: DEFAULT_ACCENT,
    offerFill: false,
    accent: DEFAULT_ACCENT,
    giftBg: '',
    giftText: '',
    giftTint: '',
    bundles: [],
    preview: false,
  };

  var THEMES = [
    {
      id: 'halloween',
      market: 'us',
      tz: 'America/New_York',
      start: '10-26',
      end: '10-31',
      label: 'Halloween Sale',
      slides: [
        'Halloween Sale · Buy 1, Get 1 Free',
        'Halloween Sale · Bundles up to 50% off',
      ],
      bannerFrom: '#241626',
      bannerTo: '#34203A',
      bannerTextColor: '#F3E6D8',
      offerColor: '#E0A060',
      offerFill: false,
      accent: '#A85A26',
      giftBg: '#F7EFE7',
      giftText: '#6E3A18',
      bundles: [
        'Buy 1, Get 1 Free (2 bottles) $39',
        'Buy 2, Get 3 Free (5 bottles) $79',
      ],
    },
    {
      id: 'early-black-friday',
      market: 'us',
      tz: 'America/New_York',
      start: '11-01',
      end: '11-22',
      label: 'Early Black Friday',
      slides: [
        'Early Black Friday · 2 bottles for $49',
        'Early Black Friday · Bundles up to 50% off',
      ],
      bannerFrom: '#1C1F24',
      bannerTo: '#262B32',
      bannerTextColor: '#FFFFFF',
      offerColor: '#9CC6E2',
      offerFill: false,
      accent: '#5B8DB3',
      giftBg: '#EEF4F9',
      giftText: '#2C4F6B',
      bundles: [
        'Buy 1, Get 1 Free (2 bottles) $39',
        'Buy 2, Get 3 Free (5 bottles) $79',
      ],
    },
    {
      id: 'black-friday-week',
      market: 'us',
      tz: 'America/New_York',
      start: '11-23',
      end: '11-25',
      label: 'Black Friday Week',
      slides: [
        'Black Friday Week · Buy 1, Get 1 Free',
        'Black Friday Week · Bundles up to 50% off',
      ],
      bannerFrom: '#0D0D0F',
      bannerTo: '#17171A',
      bannerTextColor: '#FFFFFF',
      offerColor: '#E0525A',
      offerFill: false,
      accent: '#A3161F',
      giftBg: '#F7ECEC',
      giftText: '#7A1118',
      bundles: [
        'Buy 1, Get 1 Free (2 bottles) $39',
        'Buy 2, Get 3 Free (5 bottles) $79',
      ],
    },
    {
      id: 'black-friday',
      market: 'us',
      tz: 'America/New_York',
      start: '11-26',
      end: '11-27',
      label: 'Black Friday',
      slides: [
        'Black Friday · Buy 1, Get 1 Free',
        'Black Friday · Bundles up to 50% off',
      ],
      bannerFrom: '#0A0A0A',
      bannerTo: '#1E0A0D',
      bannerTextColor: '#FFFFFF',
      offerColor: '#9E1422',
      offerFill: true,
      accent: '#9E1422',
      giftBg: '#F8ECEE',
      giftText: '#7A0F1B',
      bundles: [
        'Buy 1, Get 1 Free (2 bottles) $39',
        'Buy 2, Get 3 Free (5 bottles) $79',
      ],
    },
    {
      id: 'cyber-monday',
      market: 'us',
      tz: 'America/New_York',
      start: '11-28',
      end: '11-30',
      label: 'Cyber Monday',
      slides: [
        'Cyber Monday · Buy 1, Get 1 Free',
        'Cyber Monday · Bundles up to 50% off',
      ],
      bannerFrom: '#0F1C3F',
      bannerTo: '#1B2B5E',
      bannerTextColor: '#FFFFFF',
      offerColor: '#BFD4F2',
      offerFill: false,
      accent: '#3E5FB8',
      giftBg: '#EEF2FA',
      giftText: '#1F356F',
      bundles: [
        'Buy 1, Get 1 Free (2 bottles) $39',
        'Buy 2, Get 3 Free (5 bottles) $79',
      ],
    },
    {
      id: 'christmas-sale',
      market: 'us',
      tz: 'America/New_York',
      start: '12-01',
      end: '12-25',
      label: 'Christmas Sale',
      slides: [
        'Christmas Sale · Buy 1, Get 1 Free',
        'Christmas Sale · Bundles up to 50% off',
        'Christmas Sale · Ships before Christmas',
      ],
      bannerFrom: '#11382A',
      bannerTo: '#1A4A37',
      bannerTextColor: '#F7F0E1',
      offerColor: '#D9B872',
      offerFill: false,
      accent: '#8E1D2C',
      giftBg: '#F7F1E3',
      giftText: '#11382A',
      bundles: [
        'Buy 1, Get 1 Free (2 bottles) $39',
        'Buy 2, Get 3 Free (5 bottles) $79',
      ],
    },
    {
      id: 'new-year-sale',
      market: 'us',
      tz: 'America/New_York',
      start: '12-26',
      end: '01-03',
      label: 'New Year Sale',
      slides: [
        'New Year Sale · Buy 1, Get 1 Free',
        'New Year Sale · Bundles up to 50% off',
      ],
      bannerFrom: '#131A30',
      bannerTo: '#1F2744',
      bannerTextColor: '#FFFFFF',
      offerColor: '#D8C08A',
      offerFill: false,
      accent: '#9A7B3E',
      giftBg: '#F7F3EA',
      giftText: '#4A3A17',
      bundles: [
        'Buy 1, Get 1 Free (2 bottles) $39',
        'Buy 2, Get 3 Free (5 bottles) $79',
      ],
    },
    {
      id: 'early-black-friday',
      market: 'dach',
      tz: 'Europe/Berlin',
      start: '11-02',
      end: '11-22',
      label: 'Early Black Friday',
      slides: [
        'Early Black Friday · 2 Flaschen für 44,95 €',
        'Early Black Friday · Bundles bis zu 50% Rabatt',
      ],
      bannerFrom: '#1C1F24',
      bannerTo: '#262B32',
      bannerTextColor: '#FFFFFF',
      offerColor: '#9CC6E2',
      offerFill: false,
      accent: '#5B8DB3',
      giftBg: '#EEF4F9',
      giftText: '#2C4F6B',
      bundles: [
        '1+1 gratis (2 Flaschen) €34,95',
        '2+3 gratis (5 Flaschen) €69,95',
      ],
    },
    {
      id: 'black-friday-week',
      market: 'dach',
      tz: 'Europe/Berlin',
      start: '11-23',
      end: '11-26',
      label: 'Black Friday Week',
      slides: [
        'Black Friday Week · 1+1 gratis',
        'Black Friday Week · Bundles bis zu 50% Rabatt',
      ],
      bannerFrom: '#0D0D0F',
      bannerTo: '#17171A',
      bannerTextColor: '#FFFFFF',
      offerColor: '#E0525A',
      offerFill: false,
      accent: '#A3161F',
      giftBg: '#F7ECEC',
      giftText: '#7A1118',
      bundles: [
        '1+1 gratis (2 Flaschen) €34,95',
        '2+3 gratis (5 Flaschen) €69,95',
      ],
    },
    {
      id: 'black-friday',
      market: 'dach',
      tz: 'Europe/Berlin',
      start: '11-27',
      end: '11-29',
      label: 'Black Friday',
      slides: [
        'Black Friday · 1+1 gratis',
        'Black Friday · Bundles bis zu 50% Rabatt',
      ],
      bannerFrom: '#0A0A0A',
      bannerTo: '#1E0A0D',
      bannerTextColor: '#FFFFFF',
      offerColor: '#9E1422',
      offerFill: true,
      accent: '#9E1422',
      giftBg: '#F8ECEE',
      giftText: '#7A0F1B',
      bundles: [
        '1+1 gratis (2 Flaschen) €34,95',
        '2+3 gratis (5 Flaschen) €69,95',
      ],
    },
    {
      id: 'cyber-monday',
      market: 'dach',
      tz: 'Europe/Berlin',
      start: '11-30',
      end: '12-02',
      label: 'Cyber Monday',
      slides: [
        'Cyber Monday · 1+1 gratis',
        'Cyber Monday · Bundles bis zu 50% Rabatt',
      ],
      bannerFrom: '#0F1C3F',
      bannerTo: '#1B2B5E',
      bannerTextColor: '#FFFFFF',
      offerColor: '#BFD4F2',
      offerFill: false,
      accent: '#3E5FB8',
      giftBg: '#EEF2FA',
      giftText: '#1F356F',
      bundles: [
        '1+1 gratis (2 Flaschen) €34,95',
        '2+3 gratis (5 Flaschen) €69,95',
      ],
    },
    {
      id: 'nikolaus',
      market: 'dach',
      tz: 'Europe/Berlin',
      start: '12-03',
      end: '12-06',
      label: 'Nikolaus-Aktion',
      slides: [
        'Nikolaus-Aktion · 1+1 gratis',
        'Nikolaus-Aktion · Bundles bis zu 50% Rabatt',
      ],
      bannerFrom: '#6E1222',
      bannerTo: '#861A2B',
      bannerTextColor: '#F8EDE0',
      offerColor: '#D9B872',
      offerFill: false,
      accent: '#8A1A2C',
      giftBg: '#F8F0E6',
      giftText: '#6E1222',
      bundles: [
        '1+1 gratis (2 Flaschen) €34,95',
        '2+3 gratis (5 Flaschen) €69,95',
      ],
    },
    {
      id: 'christmas-sale',
      market: 'dach',
      tz: 'Europe/Berlin',
      start: '12-07',
      end: '12-25',
      label: 'Weihnachts-Sale',
      slides: [
        'Weihnachts-Sale · 1+1 gratis',
        'Weihnachts-Sale · Bundles bis zu 50% Rabatt',
        'Weihnachts-Sale · Lieferung vor Weihnachten',
      ],
      bannerFrom: '#11382A',
      bannerTo: '#1A4A37',
      bannerTextColor: '#F7F0E1',
      offerColor: '#D9B872',
      offerFill: false,
      accent: '#8E1D2C',
      giftBg: '#F7F1E3',
      giftText: '#11382A',
      bundles: [
        '1+1 gratis (2 Flaschen) €34,95',
        '2+3 gratis (5 Flaschen) €69,95',
      ],
    },
    {
      id: 'new-year-sale',
      market: 'dach',
      tz: 'Europe/Berlin',
      start: '12-26',
      end: '01-03',
      label: 'Neujahrs-Sale',
      slides: [
        'Neujahrs-Sale · 1+1 gratis',
        'Neujahrs-Sale · Bundles bis zu 50% Rabatt',
      ],
      bannerFrom: '#131A30',
      bannerTo: '#1F2744',
      bannerTextColor: '#FFFFFF',
      offerColor: '#D8C08A',
      offerFill: false,
      accent: '#9A7B3E',
      giftBg: '#F7F3EA',
      giftText: '#4A3A17',
      bundles: [
        '1+1 gratis (2 Flaschen) €34,95',
        '2+3 gratis (5 Flaschen) €69,95',
      ],
    },
  ];

  function getMarket() {
    if (window.MC_CAMPAIGN_MARKET === 'dach' || window.MC_CAMPAIGN_MARKET === 'us') {
      return window.MC_CAMPAIGN_MARKET;
    }
    var host = (window.location.hostname || '').toLowerCase();
    if (host.indexOf('.de') !== -1 || host.indexOf('ifst2s-jv') !== -1) return 'dach';
    return 'us';
  }

  function getPreviewId() {
    try {
      var params = new URLSearchParams(window.location.search);
      var theme = params.get('theme');
      return theme ? String(theme).trim().toLowerCase() : null;
    } catch (error) {
      return null;
    }
  }

  function partsInZone(date, timeZone) {
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
    var parts = formatter.formatToParts(date);
    var map = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') map[part.type] = part.value;
    });
    return {
      year: Number(map.year),
      month: Number(map.month),
      day: Number(map.day),
      key: map.year + '-' + map.month + '-' + map.day,
    };
  }

  function buildRange(theme, localYear) {
    var startParts = theme.start.split('-');
    var endParts = theme.end.split('-');
    var startMonth = Number(startParts[0]);
    var startDay = Number(startParts[1]);
    var endMonth = Number(endParts[0]);
    var endDay = Number(endParts[1]);
    var crossesYear = startMonth > endMonth;

    var startYear = localYear;
    var endYear = localYear;

    if (crossesYear) {
      var now = partsInZone(new Date(), theme.tz);
      if (now.month <= endMonth) {
        startYear = localYear - 1;
        endYear = localYear;
      } else {
        startYear = localYear;
        endYear = localYear + 1;
      }
    }

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    return {
      startKey: startYear + '-' + pad(startMonth) + '-' + pad(startDay),
      endKey: endYear + '-' + pad(endMonth) + '-' + pad(endDay),
    };
  }

  function isActiveByDate(theme, now) {
    var local = partsInZone(now, theme.tz);
    var range = buildRange(theme, local.year);
    return local.key >= range.startKey && local.key <= range.endKey;
  }

  function themesForMarket(market) {
    return THEMES.filter(function (theme) {
      return theme.market === market;
    });
  }

  function findTheme(market, id) {
    return themesForMarket(market).find(function (theme) {
      return theme.id === id;
    }) || null;
  }

  function resolveTheme(now) {
    var market = getMarket();
    var previewId = getPreviewId();
    var preview = false;
    var selected = null;

    if (previewId) {
      selected = findTheme(market, previewId);
      if (selected) preview = true;
    }

    if (!selected) {
      selected =
        themesForMarket(market).find(function (theme) {
          return isActiveByDate(theme, now);
        }) || null;
    }

    if (!selected) {
      return Object.assign({}, DEFAULT_CAMPAIGN, {
        market: market,
        preview: false,
      });
    }

    var firstSlide = selected.slides && selected.slides.length ? selected.slides[0] : '';
    var offerPart = firstSlide.indexOf('·') !== -1 ? firstSlide.split('·').slice(1).join('·').trim() : '';

    return {
      id: selected.id,
      market: selected.market,
      label: selected.label || '',
      eyebrow: selected.label || '',
      banner: firstSlide,
      cta: offerPart,
      slides: selected.slides ? selected.slides.slice() : [],
      bannerFrom: selected.bannerFrom,
      bannerTo: selected.bannerTo,
      bannerTextColor: selected.bannerTextColor,
      offerColor: selected.offerColor,
      offerFill: Boolean(selected.offerFill),
      accent: selected.accent,
      giftBg: selected.giftBg || '',
      giftText: selected.giftText || '',
      giftTint: selected.giftBg || '',
      bundles: selected.bundles ? selected.bundles.slice() : [],
      preview: preview,
      shell: Boolean(selected.shell),
    };
  }

  var bannerTimer = null;
  var homepageHeadingDefaults = typeof WeakMap === 'function' ? new WeakMap() : null;
  var homepageHeadingDefaultsFallback = [];

  function splitSlide(text) {
    var parts = String(text || '').split('·');
    return {
      label: (parts[0] || '').trim(),
      chip: parts.slice(1).join('·').trim(),
    };
  }

  function clearBannerTimer() {
    if (bannerTimer) {
      window.clearInterval(bannerTimer);
      bannerTimer = null;
    }
  }

  function getHomepageHeadingDefault(el) {
    if (homepageHeadingDefaults) {
      return homepageHeadingDefaults.get(el);
    }
    for (var i = 0; i < homepageHeadingDefaultsFallback.length; i += 1) {
      if (homepageHeadingDefaultsFallback[i].el === el) {
        return homepageHeadingDefaultsFallback[i].html;
      }
    }
    return undefined;
  }

  function setHomepageHeadingDefault(el, html) {
    if (homepageHeadingDefaults) {
      homepageHeadingDefaults.set(el, html);
      return;
    }
    homepageHeadingDefaultsFallback.push({ el: el, html: html });
  }

  function ensureHomepageHeadingDefault(el) {
    if (getHomepageHeadingDefault(el) === undefined) {
      setHomepageHeadingDefault(el, el.innerHTML);
    }
  }

  function setHomepageHeadingLabel(el, label) {
    var strong = el.querySelector('strong');
    if (strong) {
      strong.textContent = label;
      return;
    }
    var stringHolder = el.querySelector('.text-highlight__string');
    if (stringHolder) {
      stringHolder.textContent = label;
      return;
    }
    var highlight = el.querySelector('text-highlight');
    if (highlight) {
      var textNode = null;
      var walker = document.createTreeWalker(highlight, NodeFilter.SHOW_TEXT, null);
      while (walker.nextNode()) {
        if (walker.currentNode.nodeValue && walker.currentNode.nodeValue.trim()) {
          textNode = walker.currentNode;
          break;
        }
      }
      if (textNode) {
        textNode.nodeValue = label;
        return;
      }
    }
    el.textContent = label;
  }

  function renderHomepageSaleHeadings(campaign) {
    var nodes = document.querySelectorAll('[data-mc-campaign-heading]');
    if (!nodes.length) return;

    for (var i = 0; i < nodes.length; i += 1) {
      var el = nodes[i];
      ensureHomepageHeadingDefault(el);

      if (campaign.id && campaign.label) {
        setHomepageHeadingLabel(el, campaign.label);
        el.style.setProperty('--highlight-color', campaign.accent || DEFAULT_ACCENT);
        var highlights = el.querySelectorAll('text-highlight');
        for (var h = 0; h < highlights.length; h += 1) {
          highlights[h].style.setProperty('--icon-color', campaign.accent || DEFAULT_ACCENT);
        }
      } else {
        el.innerHTML = getHomepageHeadingDefault(el);
        el.style.removeProperty('--highlight-color');
      }
    }
  }

  function renderBanner(campaign) {
    var banner = document.querySelector('[data-mc-campaign-banner]');
    if (!banner) return;

    var track = banner.querySelector('[data-mc-campaign-banner-slides]');
    if (!track) return;

    clearBannerTimer();
    track.innerHTML = '';

    var hasSlides = Boolean(campaign.id && campaign.slides && campaign.slides.length && !campaign.shell);

    if (!hasSlides) {
      banner.hidden = true;
      return;
    }

    campaign.slides.forEach(function (text, index) {
      var parts = splitSlide(text);
      var slide = document.createElement('div');
      slide.className = 'mc-campaign-banner__slide' + (index === 0 ? ' is-active' : '');
      slide.setAttribute('data-mc-campaign-slide', String(index));

      var label = document.createElement('span');
      label.className = 'mc-campaign-banner__label';
      label.textContent = parts.label || campaign.label || '';
      slide.appendChild(label);

      if (parts.chip) {
        var divider = document.createElement('span');
        divider.className = 'mc-campaign-banner__divider';
        divider.setAttribute('aria-hidden', 'true');
        slide.appendChild(divider);

        var chip = document.createElement('span');
        chip.className = 'mc-campaign-banner__chip';
        chip.textContent = parts.chip;
        slide.appendChild(chip);
      }

      track.appendChild(slide);
    });

    banner.hidden = false;

    if (campaign.slides.length > 1) {
      var activeIndex = 0;
      bannerTimer = window.setInterval(function () {
        var slides = track.querySelectorAll('[data-mc-campaign-slide]');
        if (!slides.length) return;
        slides[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % slides.length;
        slides[activeIndex].classList.add('is-active');
      }, 4000);
    }
  }

  function applyCampaign(campaign) {
    var root = document.documentElement;

    if (campaign.id) {
      root.setAttribute('data-theme', campaign.id);
      root.setAttribute('data-mc-market', campaign.market);
    } else {
      root.removeAttribute('data-theme');
      root.setAttribute('data-mc-market', campaign.market || '');
    }

    root.style.setProperty('--mc-accent', campaign.accent || DEFAULT_ACCENT);
    root.style.setProperty('--mc-banner-from', campaign.bannerFrom || DEFAULT_ACCENT);
    root.style.setProperty('--mc-banner-to', campaign.bannerTo || DEFAULT_ACCENT);
    root.style.setProperty('--mc-banner-text', campaign.bannerTextColor || '#FFFFFF');
    root.style.setProperty('--mc-chip-outline', campaign.offerColor || DEFAULT_ACCENT);
    root.style.setProperty('--mc-chip-fill', campaign.offerFill ? campaign.offerColor || DEFAULT_ACCENT : 'transparent');
    root.style.setProperty('--mc-cream', campaign.giftBg || '#F7F7F7');
    root.style.setProperty('--mc-gift-bg', campaign.giftBg || 'transparent');
    root.style.setProperty('--mc-gift-text', campaign.giftText || 'inherit');

    if (campaign.id) {
      root.classList.add('mc-campaign-active');
      root.classList.remove('mc-campaign-default');
    } else {
      root.classList.add('mc-campaign-default');
      root.classList.remove('mc-campaign-active');
    }

    window.MC_CAMPAIGN = campaign;
    window.MC_CAMPAIGN_THEMES = THEMES;
    renderBanner(campaign);
    renderHomepageSaleHeadings(campaign);

    try {
      document.dispatchEvent(
        new CustomEvent('mc:campaign:change', {
          detail: campaign,
        })
      );
    } catch (error) {
      /* older browsers */
    }
  }

  function init() {
    applyCampaign(resolveTheme(new Date()));
  }

  window.MCCampaign = {
    themes: THEMES,
    resolve: function () {
      return resolveTheme(new Date());
    },
    apply: applyCampaign,
    refresh: init,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
